import './polyfills';

// Mirrors index.js: Sentry init must run before App.tsx is evaluated so its
// top-level `wrapRootComponent(App)` sees an initialised client. On web the
// Sentry shim is a no-op until Phase 1 wires @sentry/react.
import '../../src/services/sentry/init';

import React from 'react';
import { AppRegistry } from 'react-native';

import App from '../../App';
import { installWebApiClient } from './shell/apiClient';
import { installSessionEndedFetchGuard } from '../../src/services/auth/sessionEndedFetchGuard';
import { API_URL } from '../../src/config';
import { installInactivityLock } from './shell/inactivityLock';
import { WebAlertHost } from './shell/webAlert';
import { WebShell } from './shell/WebShell';

// Root component: the unmodified mobile App inside the browser canvas, plus
// the browser-only Alert host that renders `Alert.alert()` calls
// (react-native-web ships Alert as a no-op).
function WebRoot(): React.JSX.Element {
  return (
    <>
      <WebShell>
        <App />
      </WebShell>
      <WebAlertHost />
    </>
  );
}

// Every API call identifies as the web app and carries the API's cookies
// (docs/PLAN_web-app.md §4.3).
installWebApiClient();

// A SIGN_IN_REQUIRED 401 from the API ends the session and shows Sign In,
// whichever screen made the call (K25).
installSessionEndedFetchGuard(new URL(API_URL, window.location.href).origin);

// The phone's background/foreground lock only covers a hidden tab; this adds
// the lock for a visible tab nobody is touching (shell/inactivityLock.ts).
installInactivityLock();

const APP_NAME = 'MyFinalKeyApp';

AppRegistry.registerComponent(APP_NAME, () => WebRoot);
AppRegistry.runApplication(APP_NAME, {
  rootTag: document.getElementById('root'),
});
